import { DateFilterType } from '../enums/settings.enum';

export interface IDateFilterItems {
  filterType: DateFilterType;
  fromDate: Date | string | number | undefined;
  toDate: Date | string | number | undefined;
}

export const initialDateFilterState: IDateFilterItems = {
  filterType: DateFilterType.Today,
  fromDate: new Date(),
  toDate: new Date()
};

export const resolveDateFilterType = (
  fromDate: Date | string | number | undefined,
  toDate: Date | string | number | undefined
): DateFilterType => {
  const from = fromDate instanceof Date ? fromDate : new Date(fromDate ?? '');
  const to = toDate instanceof Date ? toDate : new Date(toDate ?? '');

  if (from.valueOf() !== to.valueOf()) {
    return DateFilterType.DateRange;
  }

  const today = new Date();
  return from.toDateString() === today.toDateString()
    ? DateFilterType.Today
    : DateFilterType.SpecificDate;
};

export const getDateFilterQueryParams = (dateFilter: IDateFilterItems) => {
  const from =
    dateFilter.fromDate instanceof Date
      ? dateFilter.fromDate
      : new Date(dateFilter.fromDate ?? '');
  const to =
    dateFilter.toDate instanceof Date
      ? dateFilter.toDate
      : new Date(dateFilter.toDate ?? '');

  return {
    fromDate: from.toISOString(),
    toDate: to.toISOString(),
    dateFilterType: dateFilter.filterType.toString()
  };
};
